import { render, staticRenderFns } from "./allRate.vue?vue&type=template&id=51f53085"
import script from "./allRate.vue?vue&type=script&lang=js"
export * from "./allRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports